import {
  DiagnosticsKind,
  type DiagnosticsEntry,
} from '@/utils/diagnostics/diagnosticsLog';

/**
 * Что показывать в журнале.
 *
 * Перенос `enum _Filter` из `diagnostics_page.dart`. В Dart подпись была
 * полем перечисления (`_Filter.all('Всё')`), здесь — отдельная карта
 * [DIAGNOSTICS_FILTER_LABEL]: так же, как у остальных перечислений порта.
 */
export const DiagnosticsFilter = {
  all: 'all',
  errors: 'errors',
  requests: 'requests',
  session: 'session',
} as const;

export type DiagnosticsFilter =
  (typeof DiagnosticsFilter)[keyof typeof DiagnosticsFilter];

/** Аналог `_Filter.values`: порядок объявления сохранён. */
export const DIAGNOSTICS_FILTER_VALUES: readonly DiagnosticsFilter[] =
  Object.values(DiagnosticsFilter);

/** Поле `label` перечисления — тексты те же, что были в Dart. */
export const DIAGNOSTICS_FILTER_LABEL: Record<DiagnosticsFilter, string> = {
  [DiagnosticsFilter.all]: 'Всё',
  [DiagnosticsFilter.errors]: 'Ошибки',
  [DiagnosticsFilter.requests]: 'Запросы',
  [DiagnosticsFilter.session]: 'Сессия',
};

/** Метод `matches` перечисления: пускать ли запись в список. */
export function diagnosticsFilterMatches(
  filter: DiagnosticsFilter,
  entry: DiagnosticsEntry,
): boolean {
  switch (filter) {
    case DiagnosticsFilter.all:
      return true;
    case DiagnosticsFilter.errors:
      return entry.isError;
    case DiagnosticsFilter.requests:
      return (
        entry.kind === DiagnosticsKind.request ||
        entry.kind === DiagnosticsKind.stream
      );
    case DiagnosticsFilter.session:
      return (
        entry.kind === DiagnosticsKind.session ||
        entry.kind === DiagnosticsKind.event
      );
  }
}
